import { CortexSetting, LocationVarKey } from "@swivl-mono/types";

import { CortexSettingRow } from "../../Components/CortexSettingRow";
import { TopicCard } from "../../Components/TopicCard";

export const TOPIC_VARS: LocationVarKey[] = [LocationVarKey.CortexProfanityHandlingOnProfanity];

const ON_PROFANITY_SETTING: CortexSetting = {
  kind: "select",
  key: "onProfanity",
  varKey: LocationVarKey.CortexProfanityHandlingOnProfanity,
  label: "On profanity",
  description: "How the bot handles profanity from a visitor.",
  options: [
    { value: "transfer-to-human", label: "Transfer to human" },
    { value: "capture-feedback", label: "Capture feedback" }
  ],
  default: "transfer-to-human"
};

export function ProfanityHandlingTopic(): React.ReactElement {
  return (
    <TopicCard title="Profanity Handling" description="What the bot does when a visitor swears at it.">
      <CortexSettingRow setting={ON_PROFANITY_SETTING} layout="horizontal" />
    </TopicCard>
  );
}
